import { Group, Stack } from "@mantine/core"

import { OperationInfo } from "~/pages/SupplierPortal/TraceabilityRequests/components/OperationInfo.tsx"
import { useTraceabilityOperations } from "~/pages/SupplierPortal/TraceabilityRequests/context/useTraceabilityOperations"
import { useInformationRequestContext } from "~/pages/SupplierPortal/TraceabilityRequests/store/InformationRequestContext"
import { isOperationOwner } from "~/pages/SupplierPortal/TraceabilityRequests/utils.ts"

import { OperationFields } from "./OperationFields"
import { OperationNotOwner } from "./OperationNotOwner"

export const TraceabilityRequestOperation = () => {
  const { user } = useInformationRequestContext()
  const { operationItem } = useTraceabilityOperations()

  const shouldShowOp =
    user && operationItem.operation
      ? isOperationOwner(operationItem.operation, user)
      : false

  return (
    <Group
      h="100%"
      align="flex-start"
      py="var(--tfg-organism-padding-y"
      px="var(--tfg-organism-padding-x)"
      w="100%"
      data-nodeid={operationItem.nodeId}
      bg={shouldShowOp ? "white" : "gray.1"}
      pos="relative"
    >
      <Stack key={operationItem.nodeId} w="100%" justify="flex-start" h="100%">
        <Group align="flex-start" mb="md">
          <OperationInfo />
        </Group>
        {shouldShowOp ? <OperationFields /> : <OperationNotOwner />}
      </Stack>
    </Group>
  )
}
